// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2m8Oj","info":"Note_info__3k-Cd","note":"Note_note__1zqVk","actions":"Note_actions__3RWyQ"};